export default {"src":"/_next/static/media/PolygonIcon.4fd1513f.svg","height":1024,"width":1024};